import type { ReactNode } from 'react';
import { Header } from './_shared';

export type OutroSlideProps = {
  eyebrow?: ReactNode;
  title: ReactNode;
  /** Optional email line, e.g. "team@streamnative.io". */
  email?: string;
  /** Optional URL line, e.g. "streamnative.io". */
  url?: string;
  /** Brand mark text shown next to the logomark. Default "StreamNative". */
  markText?: string;
  markSrc?: string;
};

export function OutroSlide({
  eyebrow,
  title,
  email,
  url,
  markText = 'StreamNative',
  markSrc = '/assets/logomark-blue.svg',
}: OutroSlideProps) {
  return (
    <div className="slide-body">
      <Header eyebrow={eyebrow ?? 'Thank you'} title={title} titleSize="h1" />
      <div className="sn-work sn-work--end">
        <div className="sn-outro">
          {email && (
            <span className="sn-outro-line">
              <strong>Email</strong> · {email}
            </span>
          )}
          {url && (
            <span className="sn-outro-line">
              <strong>Web</strong> · {url}
            </span>
          )}
          <div className="sn-mark">
            <img src={markSrc} alt={markText} />
            <span className="sn-mark-text">{markText}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
